<template>
    <div class="sheetUpdateModal">
        <Modal
            v-model="showModal"
            :class="[
                'sheetUpdateModal-modal',
                `sheetUpdateModal-modal-${editMode}`,
            ]"
            :mask-closable="false"
            :closable="false"
        >
            <template v-if="editType == 'standOut'">
                <!-- 首个分组内容 -->
                <template>
                    <!-- 头部 -->
                    <div
                        slot="header"
                        class="sheetUpdateModal-header"
                    >
                        <!-- 标题 -->
                        <div class="sheetUpdateModal-header-name">
                            {{ `${modName}${isCreate ? "添加" : canEdit ? "编辑" : "查看"}` }}
                        </div>

                        <!-- 组 -->
                        <div class="sheetUpdateModal-header-groups">
                            <!-- 操作日志 -->
                            <template v-if="!isCreate">
                                <span
                                    v-for="otherGroupItem in otherGroups"
                                    :key="otherGroupItem.key"
                                    :class="[
                                        'otherGroups-item',
                                        { 'otherGroups-item-selected': showSheetLogs }
                                    ]"
                                    style="float:right"
                                    @click="$dispatchEvent(otherGroupItem)"
                                >
                                    {{ otherGroupItem.name }}
                                </span>
                            </template>
                        </div>

                        <!-- 关闭按钮 -->
                        <dsh-icons
                            class="sheetUpdateModal-header-close"
                            :list="$getOperationList(['close'])"
                            @click="$dispatchEvent($event)"
                        ></dsh-icons>
                    </div>

                    <!-- 表单 -->
                    <dsh-form
                        v-if="showForm"
                        ref="form"
                        :canEdit="canEdit"
                        :formData="formData"
                        :formList="getCurScreenGroupFormList(curScreenGroups[0]._key)"
                        :allFormList="curScreenFormList"
                        @change="change"
                    >
                        <sheet-extra
                            v-if="formItem._enterType === 'copyData' && canEdit && formItem.canEdit"
                            slot="extra"
                            slot-scope="{ formItem }"
                            :canEdit="canEdit"
                            :modKey="modKey"
                            :formItem="formItem"
                            :formData="formData"
                        ></sheet-extra>
                    </dsh-form>

                    <!-- 操作日志 -->
                    <sheet-logs
                        v-if="showSheetLogs"
                        :modKey="modKey"
                        :dataId="dataId"
                    ></sheet-logs>
                </template>
                <!-- 后续分组内容 -->
                <div
                    v-if="curScreenGroups.length>1"
                    v-show="showForm"
                    class="sheetUpdateModal-otherGroups"
                >
                    <!-- 组 -->
                    <div class="sheetUpdateModal-header-groups sheetUpdateModal-otherGroups-header">
                        <sheet-groups
                            :groups="curScreenGroups.slice(1)"
                            @select="selectOtherGroup"
                        >
                        </sheet-groups>
                    </div>
                    <!-- 表单 -->
                    <dsh-form
                        ref="form"
                        :canEdit="canEdit"
                        :formData="formData"
                        :formList="curScreenCurGroupFormList"
                        :allFormList="curScreenFormList"
                        @change="change"
                    >
                        <sheet-extra
                            v-if="formItem._enterType === 'copyData' && canEdit && formItem.canEdit"
                            slot="extra"
                            slot-scope="{ formItem }"
                            :canEdit="canEdit"
                            :modKey="modKey"
                            :formItem="formItem"
                            :formData="formData"
                        ></sheet-extra>
                    </dsh-form>
                </div>
            </template>
            <template v-else>
                <!-- 头部 -->
                <div
                    slot="header"
                    class="sheetUpdateModal-header"
                >
                    <!-- 标题 -->
                    <div class="sheetUpdateModal-header-name">
                        {{ `${modName}${isCreate ? "添加" : canEdit ? "编辑" : "查看"}` }}
                    </div>

                    <!-- 组 -->
                    <div class="sheetUpdateModal-header-groups">
                        <sheet-groups
                            ref="sheetGroups"
                            :mode="editMode"
                            :groups="curScreenGroups"
                            :customGroups="customGroups"
                            @select="selectGroup"
                            @custom-select="customSelectGroup"
                        >
                            <!-- 操作日志 -->
                            <template v-if="!isCreate">
                                <span
                                    v-for="otherGroupItem in otherGroups"
                                    :key="otherGroupItem.key"
                                    :class="[
                                        'otherGroups-item',
                                        { 'otherGroups-item-selected': showSheetLogs }
                                    ]"
                                    @click="$dispatchEvent(otherGroupItem)"
                                >
                                    {{ otherGroupItem.name }}
                                </span>
                            </template>
                        </sheet-groups>
                    </div>

                    <!-- 关闭按钮 -->
                    <dsh-icons
                        class="sheetUpdateModal-header-close"
                        :list="$getOperationList(['close'])"
                        @click="$dispatchEvent($event)"
                    ></dsh-icons>
                </div>

                <!-- 表单 -->
                <dsh-form
                    v-if="showForm"
                    ref="form"
                    :canEdit="canEdit"
                    :formData="formData"
                    :formList="curScreenCurGroupFormList"
                    :allFormList="curScreenFormList"
                    @change="change"
                >
                    <sheet-extra
                        v-if="formItem._enterType === 'copyData' && canEdit && formItem.canEdit"
                        slot="extra"
                        slot-scope="{ formItem }"
                        :canEdit="canEdit"
                        :modKey="modKey"
                        :formItem="formItem"
                        :formData="formData"
                    ></sheet-extra>
                </dsh-form>

                <!-- 操作日志 -->
                <sheet-logs
                    v-if="showSheetLogs"
                    :modKey="modKey"
                    :dataId="dataId"
                ></sheet-logs>

                 <!-- 自定义iframe -->
                 <sheet-iframe
                    v-if="showIframe"
                    :currentIframe="currentIframe"
                    :modKey="modKey"
                    :dataId="String(dataId)"
                ></sheet-iframe>
            </template>

            <!-- 操作按钮 -->
            <div
                slot="footer"
                :class="{
                    'sheetUpdateModal-footer':true,
                    'dsh-flex-row-between-stretch': showForm,
                }"
                :style="{'justify-content': !showForm ? 'flex-end' : ''}"
            >
                <dsh-buttons
                    v-if="showForm"
                    :list="$getOperationList(['canShare', 'canPrint'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
                <dsh-buttons
                    :list="$getOperationList(showForm ? [...customDataSelfBtns, 'cancel', 'startFlow', 'save'] : ['back'])"
                    @click="$dispatchEvent($event, formData)"
                ></dsh-buttons>
            </div>
        </Modal>

        <!-- 编辑、分享、审批模态框 -->
        <dsh-render :render="dshRender"></dsh-render>
    </div>
</template>

<script>
    import sheetUpdateMixin from "./sheetUpdateMixin.js";

    export default {
        name: "sheetUpdateModal",
        mixins: [sheetUpdateMixin],
        components: {},
        props: {
            // value代表modal的显示不显示
            value: Boolean,

            dataId: String | Number,
            canEdit: {
                type: Boolean,
                default: true
            },
            isCreate: {
                type: Boolean,
                default () {
                    return true;
                }
            },

            defaultFormData: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            showModal () {
                return this.value;
            },

            filterField () {
                return this.propsObj._filterField;
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 该组件自己的初始化函数（为了区别mixin里的init）
            init () {},

            // 新增接口的回调方法
            createCb (data) {
                this.closeModal();
                this.$emit("createCb", data);
            },
            // 更新接口的回调方法
            updateCb (data) {
                this.closeModal();
                this.$emit("updateCb", data);
            },
            // 点击取消
            clickCancel () {
                if (this.canEdit) {
                    this.$signConfirm(null, this.closeModal);
                } else {
                    this.closeModal();
                }
            },

            // 关闭模态框
            closeModal (bool = false) {
                this.$emit("input", bool);
            },
            // 重点展示模式下切换后续分组
            selectOtherGroup (val) {
                this.groupKey = val._key;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/operation/update/sheetUpdateModal.vue